import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { getPrograms } from "../../services/programService";
import ParticipantRow from "../ParticipantRow";
import ProgramsCard from "../ProgramsCard/ProgramsCard";



const ProgramsList = () => {

  const [programs, setPrograms] = useState([
    {
      id: 1,
      name: "test",
    },
    {
      id: 2,
      name: "test2",
    }
  ])
  useEffect(() => {
    getPrograms().then((res) => {
      setPrograms(res);
    })
  }, [])
  return (
    <Container className="pt-4">
      {
        programs.map((p) => (
          <ProgramsCard program={p}/>
        ))
      }
    </Container>
  );
};

export default ProgramsList;
